import React, { useEffect, useState } from "react";



// core components




function Zenodo() {
  const [publications, setPublications] = useState([]);

  useEffect(() => {
    fetch("https://zenodo.org/api/records/?q=enflate")
      .then((response) => response.json())
      .then((data) => {setPublications(data.hits.hits)
        console.log(data.hits.hits)
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <>

      <section className="section section-about-us" id='zenodo' style={{padding:'10px'}}>
     
            
    <div>
    
      <ul style={{listStyle:'none',paddingLeft:'0px'}}>
        {publications.map((pub) => (
          <>
          <div style={{backgroundColor:'#3a1772',borderRadius:'10px'}}>
          <li key={pub.id} style={{  padding: "10px 30px"}}>
            {/* Τίτλος */}
           
              <a href={pub.links.doi} target="_blank" rel="noopener noreferrer">
          <h4 style={{fontSize:'17px',color:'whitesmoke',fontWeight:'600',textAlign:'left'}}>        {pub.metadata.title}    </h4>
           
        

            {/* Συγγραφείς */}
            <p style={{fontSize:'15px',textAlign:'left',color:'whitesmoke'}}><strong >Authors:</strong> {pub.metadata.creators.map(creator => creator.name.replace(",","")).join(", ")}</p>

            {/* Περιγραφή (Μικρό απόσπασμα) */}
            {pub.metadata.description ? (
              <p style={{fontSize:'15px',textAlign:'left',color:'whitesmoke'}}><strong>Description:</strong> {pub.metadata.description.slice(0, 200).replace("<p>","").replace("</p>","")}...</p>
            ) : (
              <p style={{fontSize:'15px',textAlign:'left',color:'whitesmoke'}}><strong>Description:</strong> No description available.</p>
            )}
              <p style={{fontSize:'14px',textAlign:'left',color:'whitesmoke'}}><strong>Published in: </strong>Zenodo</p>
            <p style={{fontSize:'15px',textAlign:'left'}}><strong style={{color:'whitesmoke'}}>Link:</strong> <a href={pub.doi_url}>{pub.doi_url}</a></p>
      </a>     </li> </div> <br/> </>
        ))}
      </ul>
    </div>  
          
          </section> 
          </>
  );
};

export default Zenodo;
